import { Button, ButtonProps } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

function InnerLink(href: string) {
  return React.forwardRef<Link, ButtonProps>(({ className, children }) => (
    <a className={className} href={href}>
      {children}
    </a>
  ));
}

interface Props {
  readonly children: React.ReactNode;
  readonly disabled?: boolean;
  readonly href: string;
}

function CustomLink({ children, href, disabled }: Props) {
  return (
    <Button color="primary" disabled={disabled} component={InnerLink(href)}>
      {children}
    </Button>
  );
}

export default CustomLink;
